import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeAnimation } from 'app/shared/animations/route-animations';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { BasketWithPrice, BookBasketOffer, SelectBasketOffer, SessionList } from 'app/shared/models/class/basket/basketList';
import { PromoCodePricing } from 'app/shared/models/class/discount/discount';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasketBookable } from 'app/shared/models/class/session-basket/session-basket';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Tag } from 'app/shared/models/class/tags/tag';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { DiscountService } from 'app/shared/services/discount/discount.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { SetRouteService } from 'app/shared/services/set-route/set-route.service';
import { TagService } from 'app/shared/services/tag/tag.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';
import { OpenDialogCommentBasketComponent } from '../dialog/open-dialog-comment-basket/open-dialog-comment-basket.component';
import { OpenDialogConfirmBookedComponent } from '../dialog/open-dialog-confirm-booked/open-dialog-confirm-booked.component';
import { OpenDialogConfirmComponent } from '../dialog/open-dialog-confirm/open-dialog-confirm.component';
import { BookingService } from 'app/shared/services/booking/booking.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [fadeAnimation]
})
export class HomeComponent extends SubscriptionBaseComponent implements OnInit {


  openSearch: boolean;
  showTags: boolean;

  tags: Tag[] = [];
  tagsSelected: Tag[] = [];
  widthScreen: number;
  offers: any[];
  userConnected: InfosUser;
  universe = 1;
  bookedOpen = false;
  myShoppingBag: FullOffer[];
  offerAddToPayment: FullOffer[];
  offerIsCompleted: FullOffer[];

  authoToClick = true;
  valueInput: any;
  coordinatesSearch: any;

  searchForm: UntypedFormGroup;
  totalPrice: number;

  color: ThemePalette = 'primary';
  innerWidth: number;
  basketWithPrice: BasketWithPrice;

  flag1 = false;
  discountForm: UntypedFormGroup;
  totalDiscount: any;
  messageDiscount: any;
  activePromoCode: boolean;
  userKey: number;
  licences: FullOffer[];
  cgvAccepted = false;
  pdfTrust: any;
  isLoadingCGV = false;

  constructor(
    private dataService: DataService,
    public router: Router,
    private route: ActivatedRoute,
    private setRouteService: SetRouteService,
    private tagsService: TagService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private sessionBasketService: SessionBasketService,
    private dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    private discountService: DiscountService,
    private clubService: ClubService,
    private sanitizer: DomSanitizer,
    private pdfService: PdfService,
    private uiService: UiService,
    private faIconService: FaiconService,
    private bookingService: BookingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    if (this.userConnected) {
      this.getBasketListUserConnected();
    }


    this.initForm();
    if (this.router.url === '/home') {
      this.setRouteService.setRouteSessionStrorage();
    }
    this.getTags();

  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  inHomePage(): boolean {
    const { url } = this.router;
    const urlSplit = this.router.url.split('/');
    const check = ['sign-in', 'my-wishes', 'my-shopping-bag', 'purchases-history'];

    return url.search('home') && !check.includes(urlSplit[2]) && !urlSplit[2]?.search('offerKey') ? true : false;
  }


  opendBasketDiv(): void {
    this.bookedOpen = !this.bookedOpen;
    this.dataService.bookedOpen$.next(this.bookedOpen);
    const basket = document.getElementById('total_booked');

    this.bookedOpen ?
      basket.classList.replace('total_booked_close', 'total_booked_open') :
      basket.classList.replace('total_booked_open', 'total_booked_close');

    this.initFormDiscount();
  }

  getSumTotal(): number {
    const totalArray = this.offerAddToPayment?.map(o => o.fixedPrice);
    let total = 0;
    if (totalArray?.length) { total = totalArray?.reduce((a, b) => a + b); }
    return totalArray?.length ? total : 0;
  }

  allMyOffersIsComplete(): boolean {
    const isAllComplete = this.offerAddToPayment?.filter(o => o.isComplete && o.isSelected);
    const isSelected = this.offerAddToPayment?.filter(o => o.isSelected);
    return (isAllComplete.length === isSelected.length) && isSelected.length && this.cgvAccepted ? true : false;
  }

  allMyOffersIsCompleteForQuote(): boolean {
    const isAllComplete = this.offerAddToPayment.filter(o => o.isComplete && o.isSelected);
    const isSelected = this.offerAddToPayment.filter(o => o.isSelected);
    return (isAllComplete.length === isSelected.length) && isSelected.length ? true : false;
  }

  getOffertoPersoNoComplete(): FullOffer[] {
    const offertoPerso = this.offerAddToPayment?.filter(o => o?.parameters && !o?.parametersValues);
    return offertoPerso;
  }

  bookOffer(): void {
    this.authoToClick = false;

    const offerAddToPaymentFiltered = [...this.offerAddToPayment.filter(o => o.isComplete && o.isSelected), ...this.licences];
    const basketOffer: string[] = offerAddToPaymentFiltered.map((o, i) => o.offerKey.toString());
    const uniqueBasketOffer = [...new Set(basketOffer)];

    const sessionsList: SessionList[] = offerAddToPaymentFiltered.map((el) => {
      return {
        sessionBasketKey: el.sessionBasketKey,
        sessionTotalPrice: el.sessionTotalPrice
      };
    });

    const total = this.basketWithPrice.grandDiscount > 0 ? this.basketWithPrice.discountedGrandTotal : this.basketWithPrice.grandTotal;
    const myOrder = new BookBasketOffer(+this.userConnected.sub, uniqueBasketOffer, total, sessionsList);

    if (this.basketWithPrice.promoCodeDiscount && this.basketWithPrice.promoCodeName) {
      myOrder.promoCodeDiscount = this.basketWithPrice.promoCodeDiscount;
      myOrder.promoCodeName = this.basketWithPrice.promoCodeName;
    }

    if (this.basketWithPrice.fullOfferList.every((offer) => offer.isPayableAtClub === true && offer.isPayableOnline === false)) {
      // si au total il n'y a que des offres de paiement au club
      this.openDialogCommentAndPaymentToClub(myOrder);
    } else {
      this.openDialogConfirmBooked(myOrder, offerAddToPaymentFiltered);
    }
  }

  openDialogConfirmBooked(myOrder: BookBasketOffer, offers: FullOffer[]): void {
    const dialogRef = this.dialog.open(OpenDialogConfirmBookedComponent, {
      data: { myOrder, offers, licences: this.licences },
      // height: '50%'

    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        this.authoToClick = true;
        this.opendBasketDiv();

        if (res) {
          this.cancelBookedSession(res);
          this.opendBasketDiv();
        } else {
          this.getBasketListUserConnectedFetch();
        }
      }
    });
  }


  private cancelBookedSession(bookingKey: number) {
    this.bookingService.cancelBookedSession(bookingKey).subscribe({
      next: res => {
        this.getBasketListUserConnected();
      }
    });
  }

  openDialogCommentAndPaymentToClub(myOrder: BookBasketOffer) {
    const dialogRef = this.dialog.open(OpenDialogCommentBasketComponent, {
      data: { order: myOrder },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: res => {
        if (res) {
          this.sessionBasketService.checkSessionBasketBookable(this.userKey).subscribe({
            next: res => {
              res.every((el: SessionBasketBookable) => el.isBookable) ?
                this.bookMyOrder(myOrder) :
                this.uiService.showSnackbar('Une de vos sessions n\'est plus disponible');
            }
          });
        } else {
          this.authoToClick = true;
        }
        this.cgvAccepted = false;
      }
    });
  }

  bookMyOrder(myOrder): void {
    this.sessionBasketService.bookOffer(myOrder).subscribe({
      next: res => {
        this.cgvAccepted = false;
        // this.cancelBookedSession(res);
        this.authoToClick = true;
        this.uiService.showSnackbar('Réservation réussie');

        this.getBasketListUserConnected();
      }
    });
  }
  addToPayment(offer: FullOffer): void {
    const selection = new SelectBasketOffer(this.userKey, offer.offerBasketKey, !offer.isSelected);

    if (this.innerWidth <= 768) {
      this.dataService.updateBasketInMobile$.next(true);
    }

    this.sessionBasketService.selectBasketOffer(selection).subscribe({
      next: () => {
        this.getBasketListUserConnected();
      }
    });
  }

  noOfferInBasket(): FullOffer[] {
    return this.offerAddToPayment.filter(el => el.isSelected);
  }

  applyPromoCode(): void {
    this.sessionBasketService.applyPromoCodeToSessionBasket(this.userKey, this.f.promoCodeName.value).subscribe({
      next: res => {
        this.licences = [];
        this.basketWithPrice = res;
        this.totalPrice = res.grandTotal;
        this.licences = [...res.fullOfferList.filter(o => o.isLicence)];
        this.uiService.showSnackbar('Code Promo appliqué avec succès sur votre panier', false);
      },
      error: error => {
        console.error("error", error);
      }
    })
  }

  universIsSelected(indexUniverse: number): boolean {
    const { universe } = this.route.snapshot.queryParams;
    let isSelected = false;

    if (+universe === indexUniverse || (!universe && indexUniverse === 1)) {
      isSelected = true;
    }
    return isSelected;
  }

  getSessionOfferBasket(offerBasket: FullOffer): OfferSession {
    return offerBasket.sessions.find(o => o.sessionKey === offerBasket.sessionKey);
  }

  acceptCGV(): void {
    this.cgvAccepted = !this.cgvAccepted;
  }

  getPdfBasket(): void {
    const { sub: userKey } = this.authService.getDecodedToken();

    if (this.totalPrice && this.allMyOffersIsCompleteForQuote()) {

      this.pdfService.getPdfBasket(+userKey).subscribe({
        next: blob => {
          const data = window.URL.createObjectURL(<any>blob.body);
          const anchor = document.createElement('a');
          anchor.href = data;
          const date = new Date();
          const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
          anchor.href = data;
          anchor.download = `NPHDF-${date.getFullYear()}-${this.myShoppingBag[0].sessionBasketKey}-${time}`;
          anchor.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(data);
          }, 100);
        }
      });
    } else {
      this.uiService.showSnackbar('Vous devez configurer toutes vos offres pour télécharger votre devis.');

    }
  }

  private formatCoord(event): string {
    this.coordinatesSearch = event;
    const coordinates = [];

    switch (typeof event?.geometry?.location.lat) {
      case 'function':
        coordinates.push(event?.geometry.location.lat().toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng().toString().replace('.', ','));
        break;
      case 'number':
        coordinates.push(event?.geometry.location.lat.toString().replace('.', ','));
        coordinates.push(event?.geometry.location.lng.toString().replace('.', ','));
        break;

      default:
        break;
    }

    return coordinates.join(';');
  }

  private getBasketListUserConnected(): void {
    this.sessionBasketService.getBasketList(this.userKey).subscribe({
      next: basket => {
        this.dataService.myShoppingBag.next(basket);
        this.dataService.updateBasketInMobile$.next(false);
        this.activePromoCode = this.checkCodePromo(basket);
      }
    });

  }

  private getBasketListUserConnectedFetch(): void {
    fetch(`${environment.apiUrl}/SessionBasket/${this.userKey}`, {
      method: 'get',
      headers: { authorization: `Bearer ${localStorage.getItem(`${environment.tokenKey}`)}` }
    })
      .then(response => response.json())
      .then((response) => {
        this.myShoppingBag = response.sort((a, b) => {
          return (b.isSelected as any) - (a.isSelected as any);
        });
        this.dataService.myShoppingBag.next(this.myShoppingBag);
        // }
        this.dataService.updateBasketInMobile$.next(false);

        this.activePromoCode = this.checkCodePromo(response);
        this.getPricingBasket();

      })
      .catch((error) => {
        console.error('error', error);
      });
  }

  private getPricingBasket(): void {
    this.userKey = this.authService.getDecodedToken()?.sub;
    this.sessionBasketService.getPriceSession(this.userKey).subscribe({
      next: basketWithPrice => {
        this.basketWithPrice = basketWithPrice;
        const offer = this.getOfferAddToPayment([...basketWithPrice?.fullOfferList]);
        this.offerAddToPayment = offer.filter(o => !o.isLicence);
        this.licences = offer.filter(o => o.isLicence);
        this.activePromoCode = this.checkCodePromo(this.offerAddToPayment);
        this.totalPrice = basketWithPrice.grandTotal;
        if (this.innerWidth <= 768) {
          this.dataService.updateBasketInMobile$.next(false);
        }
        // const clubCode = [...this.offerAddToPayment.filter(o => !o.isLicence)][0].clubCode;
        // this.getCGV(clubCode);

      }
    });
  }

  private checkCodePromo(basket: FullOffer[]): boolean {
    const basketFilter = basket.filter(o => o.isSelected && o.isComplete);
    const offerKeys = basketFilter.map(o => o.offerKey);
    const offerKeyBase = offerKeys[0];
    return offerKeys.every(o => o === offerKeyBase) ? true : false;
  }

  private getOfferAddToPayment(offerAddToPayment: FullOffer[]): FullOffer[] {
    const basketOfferKeysMyShoppingBag = this.myShoppingBag.map(o => o.sessionBasketKey);
    const result = this.myShoppingBag.filter(o1 => !offerAddToPayment.some(o2 => o1.sessionBasketKey === o2.sessionBasketKey));
    const newOfferAddToPayment = [...offerAddToPayment, ...result];

    return newOfferAddToPayment.sort((a, b) => {
      const aValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(a)[0]);
      const bValue = basketOfferKeysMyShoppingBag.indexOf(Object.values(b)[0]);
      return aValue - bValue;
    });
  }

  private getTags(): void {
    this.tags = [];
    this.tagsService.getTagsByUniverse(this.universe).subscribe({
      next: tags => {
        tags?.forEach(t => {
          if (['Groupe', 'Sensation', 'Niveau'].includes(t.tagTypeName)) {
            t.tags.forEach(tag => {
              this.tags.push(tag);
            });
          }
        });
      }
    });
  }

  // private getCGV(clubCode: string): void {
  //   this.isLoadingCGV = true;
  //   this.clubService.getCGV(clubCode).subscribe({
  //     next: cgv => {
  //       const pdf = `data:application/pdf;base64,${cgv}`;
  //       this.pdfTrust = this.sanitizer.bypassSecurityTrustUrl(pdf);
  //       this.isLoadingCGV = false;
  //     }
  //   });
  // }

  private getCGV(clubCode: string): void {
    this.isLoadingCGV = true;
    this.clubService.getCGV(clubCode).subscribe({
      next: async res => {
        const base64URL = res;
        const binary = atob(base64URL.replace(/\s/g, ''));
        const len = binary.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);

        for (let i = 0; i < len; i += 1) {
          view[i] = binary.charCodeAt(i);
        }
        // create the blob object with content-type "application/pdf"
        const blob = new Blob([view], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Conditions_générales_de_vente.pdf`;
        anchor.click();

        this.isLoadingCGV = false;
      }
    });
  }

  downloadCGV(): void {
    const clubCode = [...this.offerAddToPayment.filter(o => !o.isLicence)][0].clubCode;
    this.getCGV(clubCode);
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    let coordinates = null;
    if (sessionStorage.getItem('coordinates')) {
      coordinates = JSON.parse(sessionStorage.getItem('coordinates'));
      if (coordinates) {
        this.valueInput = coordinates.name;
      }
    }

    this.searchForm = this.formBuilder.group({
      keyword: [coordinates?.name || '', Validators.required]
    });
  }

  get fD() {
    return this.discountForm.controls;
  }

  private initFormDiscount(): void {
    this.discountForm = this.formBuilder.group({
      promoCodeName: ['']
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    // this.userKey = +this.userConnected?.sub;
    this.dataService.bookedOpen$.next(false);
    this.dataService.tabHome$.next('home');
    this.dataService.openSearchOffer$.next(false);
    this.userKey = +this.authService.getDecodedToken()?.sub;

    const { structure, universe } = this.route.snapshot.queryParams;

    if (universe) {
      this.universe = universe;
    }

    this.innerWidth = window.innerWidth;

    if (this.innerWidth <= 768) {
      this.initSub();
    }

    if (sessionStorage.getItem('tags') && sessionStorage.getItem('tags') === 'W10=') {
      sessionStorage.removeItem('tags');
      this.tagsSelected = [];

    }

    // this.checkTagSelected();

  }

  private initSub(): void {
    this.flag1 = true;
    this.subscription
      .add(
        this.dataService.tagSelected$.subscribe({
          next: tags => {
            this.tagsSelected = tags;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.myShoppingBag.subscribe({
          next: myShoppingBag => {
            this.myShoppingBag = myShoppingBag;
            this.offerIsCompleted = myShoppingBag.filter(o => (!o.isComplete && !o?.parameters) || o.isComplete);
            if (this.innerWidth <= 768 && this.userConnected) {
              this.getPricingBasket();
            }
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.bookedOpen$.subscribe({
          next: bookedOpen => this.bookedOpen = bookedOpen
        })
      )
      .add(
        this.dataService.showTagSearch$.subscribe({
          next: showTag => {
            this.showTags = showTag;
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.updateBasketInMobile$.subscribe({
          next: update => {

            if (update) {
              this.getBasketListUserConnected();
              // this.getPricingBasket();

            }

          }
        })
      )
      .add(
        this.authService.authChanged.subscribe(result => {
          if (result) {
            this.userConnected = this.authService.getDecodedToken();
          }
        })
      )

  }


  goHome(): void {
    let clubCode = [...this.offerAddToPayment.filter(o => !o.isLicence)][0].clubCode;
    sessionStorage.setItem('clubCodeForHomeOffers', clubCode);
    const urlInSessionStorage = sessionStorage.getItem('route');
    sessionStorage.getItem('route') ?
      this.router.navigateByUrl(urlInSessionStorage) :
      this.router.navigate(['/home']);
  }

  removePromoCode() {
    this.discountForm.reset();
    this.getPricingBasket();
  }

}
